<ng-container *ngIf="provider; else noProvider">
    <!-- Not a btn-group: it does not wrap, and its overlapped borders look thick. -->
    <div class="d-flex flex-wrap align-items-center mb-2">
        <span class="kt-font-bold toolbar-label">Currency</span>
        <div class="currency-tabs" role="group">
            <button *ngFor="let ccy of currencies" type="button" class="currency-tab"
                [class.active]="+ccy.id === currencyId" (click)="currencyId = +ccy.id">
                {{ ccy.name }}
                <span *ngIf="!isDefault && hasValues(ccy.id)" class="kt-badge kt-badge--success kt-badge--dot ml-1" matTooltip="Has group values for this bet type"></span>
            </button>
        </div>
    </div>
    <div class="d-flex flex-wrap align-items-center mb-3">
        <ng-container *ngIf="provider.bet_types.length">
            <span class="kt-font-bold toolbar-label">Bet Type</span>
            <div class="bet-type-select mr-4">
                <kt-dropdown-wo-lazyload
                    [form]="betTypeForm"
                    [formName]="'bet_type_code'"
                    [dropdownList]="betTypeItems"
                    [dropdownSettings]="betTypeSettings"
                    [selectionAttributes]="'code'"
                    [selectedItems]="betTypeSelected"
                    (selectedItemsChanged)="onBetTypeChanged($event)">
                </kt-dropdown-wo-lazyload>
            </div>
        </ng-container>
        <!-- Acts on the currency and bet type shown, so it sits with those controls. -->
        <button *ngIf="!isDefault && !readonly" type="button" class="btn btn-secondary btn-sm ml-auto" (click)="onCopyFromDefault()">Copy from Default</button>
    </div>

    <div class="alert alert-secondary py-2">
        <p class="m-0">{{ isDefault ? 'An empty cell uses All Sports, shown in grey.' : 'An empty cell uses the provider default, shown in grey.' }}</p>
        <p *ngIf="isMixParlay" class="m-0">Mix Parlay limits every parlay, whatever its sports, so it has one row: All Sports.</p>
    </div>

    <div class="table-responsive limit-grid">
        <table class="table table-bordered table-hover table-striped mb-0">
            <thead>
                <tr>
                    <th class="w-25">Sport</th>
                    <th *ngFor="let f of fields" class="text-right">{{ f.label }} <small class="d-block text-muted">{{ currencyName }}</small></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let sport of rows; trackBy: trackBySport">
                    <tr>
                        <td><small class="text-muted mr-2">{{ sport.code }}</small>{{ sport.label }}</td>
                        <td *ngFor="let f of fields">
                            <input type="text" inputmode="numeric" class="form-control form-control-sm text-right" [readonly]="readonly"
                                [class.is-invalid]="error(sport)"
                                [value]="value(sport, f.key)" [placeholder]="placeholder(sport, f.key)"
                                (change)="onInput(sport, f.key, $event.target.value)">
                        </td>
                    </tr>
                    <tr *ngIf="error(sport)">
                        <td [attr.colspan]="fields.length + 1" class="text-danger small py-1">
                            {{ currencyName }} · {{ sport.label }}: {{ error(sport) }}
                        </td>
                    </tr>
                </ng-container>
                <tr *ngIf="rows.length === 0">
                    <td [attr.colspan]="fields.length + 1" class="text-center text-muted">
                        No sports for this provider.
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="mt-2">
        <small class="text-muted">{{ provider.code }} · {{ currencyName }} · bet type {{ betTypeCode }} · {{ setCount }} of {{ rows.length }} sports set</small>
    </div>
</ng-container>

<ng-template #noProvider>
    <div class="alert alert-secondary"><p class="m-0">Select a sport provider in Group Info first.</p></div>
</ng-template>
